import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ParcelInstrument } from '@models/teranet';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ButtonGroupOption } from 'src/app/shared/atomic/atoms/button-group/button-group.component';
import { ICON } from '@core/util/icon';

@UntilDestroy()
@Component({
	selector: 'app-new-teranet-requisition-modal',
	templateUrl: 'new-teranet-requisition-modal.component.html',
	styleUrls: ['./new-teranet-requisition-modal.component.scss'],
	standalone: false,
})
export class NewTeranetRequisitionModalComponent {
	public tabs: ButtonGroupOption<number>[] = [
		{ label: 'Instruments', value: 1 },
		{ label: 'Writs', value: 2 },
	];

	public selectedTab = 1;

	public instruments: ParcelInstrument[];
	public ICON = ICON;

	constructor(
		private dialogRef: MatDialogRef<NewTeranetRequisitionModalComponent>,
	) {}

	closeModal() {
		this.dialogRef.close();
	}
}
